import { SERVICE_FLOW_CONFIGURATION_MODES } from '../../constants/configurationModes';
import { SERVICE_FLOW_QUERY_KEYS } from '../../constants/queryKeys';

// Builds one payload entry per active configurator; merged-out cards (hidden by "same for all")
// take the merged card's values, one payload entry per merged-out serial.
export async function buildSubmitConfigs({ activeConfigurators, mergedOutConfigurators, action, purchaseOrderNumber }) {
  const isEdit = !!new URLSearchParams(window.location.search)
    .get(SERVICE_FLOW_QUERY_KEYS.CONFIGURATION_GUID)
    ?.trim();
  const configurationMode = isEdit
    ? SERVICE_FLOW_CONFIGURATION_MODES.EDIT
    : SERVICE_FLOW_CONFIGURATION_MODES.NEW;

  const configs = await Promise.all(
    activeConfigurators.map(async (configurator) => {
        const config = await configurator.getValues(action, configurationMode);
        const configWithPurchaseOrder =
            purchaseOrderNumber === undefined
                ? config
                : {
                    ...config,
                    Data: {
                        ...config.Data,
                        PONumber: purchaseOrderNumber,
                    },
                };

      const copies = mergedOutConfigurators.map((other) => ({
        ...configWithPurchaseOrder,
        Data: { ...configWithPurchaseOrder.Data, SerialNumber: other.serialNumber },
      }));

      return [configWithPurchaseOrder, ...copies];
    }),
  );

  return configs.flat();
}

// Posts the built configs to the submit-order endpoint; throws (with serverMessage) on failure.
export async function submitOrder(configs) {
  const response = await fetch('/api/config/submitorder', {
    method: 'POST',
    headers: { 'Content-type': 'application/json' },
    body: JSON.stringify({ Configurators: configs }),
  });

  if (!response.ok) {
    const errorBody = await response.json().catch(() => null);
    const requestError = new Error('Submit order request failed with status ' + response.status);
    requestError.serverMessage = errorBody?.Message;
    throw requestError;
  }

  return response.json();
}

// Matches failed results to configurators by configuratorId+serialNumber, falling back to
// configuratorId only for merged-out serials; renders inline errors and collects the rest.
export function matchSubmitErrors({ failedResults, configurators }) {
  const unmatchedErrors = [];
  let hasInlineErrors = false;

  failedResults.forEach((result) => {
    const errors = result?.Result?.Errors || [];
    const configurator =
      configurators.find(
        (c) => c.configuratorId === result.ConfiguratorId && c.serialNumber === result.SerialNumber,
      ) || configurators.find((c) => c.configuratorId === result.ConfiguratorId);

    if (!configurator) {
      unmatchedErrors.push(...errors);
      return;
    }

    const unmatched = configurator.renderServerErrors(errors);
    hasInlineErrors = hasInlineErrors || unmatched.length < errors.length;
    unmatchedErrors.push(...unmatched);
  });

  return { unmatchedErrors, hasInlineErrors };
}
